<template>
  <div style="padding-bottom:45px;">
    <div v-if="servicoscontrados">
        <div class="alert alert-info">
            No momento você já em todos serviços contradados.
        </div>
    </div>
    <ul
      v-else
      class="process-steps row col-mb-30 ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapaInicial == 'Inicial'}"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEtapaInicial('Inicial')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
        >1</a>
        <h5>Valores</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapaInicial == 'Contrato'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapaInicial('Contrato')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
        >2</a>
        <h5>Contrato</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapaInicial == 'Pagamento'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab3"
        aria-labelledby="ui-id-3"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapaInicial('')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-3"
        >3</a>
        <h5>Pagamento</h5>
      </li>
    </ul>
    <div v-if="!servicoscontrados">
    <div class="card-header list-group-item list-group-item-action active">
      <h4 class="mb-0">{{servico.titulo}}</h4>
    </div>
    <div class v-if="etapaInicial == 'Inicial'">
      <div class="card mb-3">
        <!-- Default panel contents -->
        <!-- Table -->
        <table class="table">
          <thead>
            <tr v-if="!servico.renovacao">
              <th colspan="3" class="text-center">CONTRATAÇÃO DO SERVIÇO, VALIDADE DE 1 ANO</th>
            </tr>
            <tr v-else>
              <th colspan="3" class="text-center">RENOVAÇÃO DO SERVIÇO, VALIDADE DE 1 ANO</th>
            </tr>
            <tr>
              <th>Tabela de preços</th>
              <th>Valor associado Sindifupi ou Abraesa</th>
              <th>Valor não associado Sindifupi ou Abraesa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="servico.linha == 'preco1Ate'">
              <td>Até 12 colaboradores incluindo o diretor e gerente</td>
              <td>R$ {{precoFormato(servico.precoParceiro)}}</td>
              <td>R$ {{precoFormato(servico.precoContratacao)}}</td>
            </tr>
            <tr v-else-if="servico.linha == 'preco2Ate'">
              <td>de 13 a 30 colaboradores incluindo o diretor e gerente</td>
              <td>R$ {{precoFormato(servico.precoParceiro)}}</td>
              <td>R$ {{precoFormato(servico.precoContratacao)}}</td>
            </tr>
            <tr v-else>
              <td>de 31 pra cima incluindo o diretor e gerente</td>
              <td>R$ {{precoFormato(servico.precoParceiro)}}</td>
              <td>R$ {{precoFormato(servico.precoContratacao)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="align-self-end" style="display: flex;">
        <div class="ml-auto form-group">
          <label>Usar desconto de afiliado?</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': servico.desconto == true}"
              @click="servico.desconto = true"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                :value="true"
                autocomplete="off"
                class="valid"
              /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': servico.desconto == false}"
              @click="servico.desconto = false"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                :value="false"
                autocomplete="off"
                class="valid"
              /> Não
            </label>
          </div>
        </div>
      </div>
      <div class="align-self-end" style="display: flex;">
        <button
          class="btn btn-primary ml-auto"
          @click.prevent="fnEtapaInicial('Contrato')"
        >Continuar</button>
      </div>
    </div>
    <div class v-if="etapaInicial == 'Contrato'">
      <div class="card mb-3">
        <div class="card-header">Termo de contratação</div>
        <div class="card-body">
          <p class="card-text" v-html="servico.textoContrato"></p>
        </div>
        <div class="card-footer">
          <div class="text-right">
            <span class v-if="servico.desconto">
              Valor associado Sindifupi ou Abraesa
              -
              <span
                v-if="servico.linha == 'preco1Ate'"
              >Até 12 colaboradores incluindo o diretor e gerente</span>
              <span
                v-else-if="servico.linha == 'preco2Ate'"
              >de 13 a 30 colaboradores incluindo o diretor e gerente</span>
              <span v-else>de 31 pra cima incluindo o diretor e gerente</span>
              -
              <b>R$ {{precoFormato(servico.precoParceiro)}}</b>
            </span>
            <span class v-else>
              Valor não associado Sindifupi ou Abraesa
              -
              <span
                v-if="servico.linha == 'preco1Ate'"
              >Até 12 colaboradores incluindo o diretor e gerente</span>
              <span
                v-else-if="servico.linha == 'preco2Ate'"
              >de 13 a 30 colaboradores incluindo o diretor e gerente</span>
              <span v-else>de 31 pra cima incluindo o diretor e gerente</span>
              -
              <b>R$ {{precoFormato(servico.precoContratacao)}}</b>
            </span>
          </div>
        </div>
      </div>

      <div class="align-self-end" style="display: flex;">
        <button class="btn btn-warning mr-auto" @click.prevent="fnEtapaInicial('Inicial')">VOLTAR</button>
        <button
          v-if="etapaInicial == 'Contrato'"
          class="btn btn-primary ml-auto"
          @click.prevent="fnContratar"
        >CONTRATAR</button>
      </div>
    </div>
    <div v-if="etapaInicial == 'Pagamento'">
    <div class="row">
      <div class="col-sm-12">
        <table class="table cart table-striped">
          <thead>
            <tr>
              <th class="cart-product">Código da contratação</th>
              <th class="cart-product">Serviço</th>
              <th class="cart-product">Perfil</th>
              <th class="cart-product text-right">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr class="cart_item">
                 <td>
                   <b>{{contratacao.codigoContratacao}}</b>
                </td>
               <td>
                    ({{servico.abreviacao}}) - {{servico.titulo}}<br>
                </td>
                <td v-if="servico.linha == 'preco1Ate'">
                    Até 12 colaboradores incluindo o diretor e gerente
                </td>
                <td  v-else-if="servico.linha == 'preco2Ate'">
                    (de 13 a 30 colaboradores incluindo o diretor e gerente
                </td>
                <td  v-else >
                    de 31 pra cima incluindo o diretor e gerente
                </td>

                <td class="text-right">
                   R$ {{ precoFormato(contratacao.preco)}}
                </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
      <form style="display: flex; justify-content:flex-end;"
        target="pagseguro"
        method="post"
        action="https://pagseguro.uol.com.br/v2/checkout/payment.html"
      >
        <input type="hidden" name="receiverEmail" value="pericia@gape.com.br" />
        <input type="hidden" name="currency" value="BRL" />
        <input type="hidden" name="encoding" value="UTF-8" />
        <input type="hidden" name="itemId1" :value="contratacao.codigoContratacao" />
        <input type="hidden" name="itemDescription1" :value="servico.titulo" />
        <input type="hidden" name="itemQuantity1" value="1" />
        <input name="reference" type="hidden" :value="contratacao.codigoContratacao">  

        <vue-numeric
          v-bind:precision="2"
          type="hidden"
          name="itemAmount1"
          :value="contratacao.preco"
        />
        <button type="submit" class="btn btn-success">EFETUAR PAGAMENTO VIA PAGSEGURO</button>
      </form>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatPrice, userClient } from "../../global/utils";
export default {
  data() {
    return {
      servico: {},
      servicoStorage: {},
      cliente: {},
      temConteudo: false,
      contratacao: {},
      servicoscontrados: false,
    };
  },
  computed: mapState(["client", "etapaInicial"]),
  mounted() {
    this.fnCarregaItems();

    this.cliente = userClient();
  },
  components: {},
  methods: {
    async fnCarregaItems() {
      if (this.$route.params.idServico != undefined) {
        await this.$http
          .get("servicos/api/contrata/" + this.$route.params.idServico)
          .then((res) => {
            this.servico = res.data;

            if (this.servico.contratacoes != null) {
              this.contratacao = this.servico.contratacoes;
              if (this.contratacao.pago){
                  this.redireciona()
              }
              this.$store.commit("setEtapaInicial", "Pagamento");
            } else {
              this.$store.commit("setEtapaInicial", "Inicial");
            }
            this.$store.commit("setContratar", this.servico);
          })
          .catch(() => {});
      }
    },
    precoFormato(value) {
      return formatPrice(value);
    },
    fnEtapaInicial(value) {
      if (this.$store.state.etapaInicial != "Pagamento") {
        if (value != "") {
          this.$store.commit("setEtapaInicial", value);
        } else {
          this.$toasted.global.defaultError({
            msg: "Finalize a contratação do serviço",
          });
        }
      } else {
        this.$toasted.global.defaultInfo({
          msg: "Contratação disponível para pagamento",
        });
      }
    },
    fnContratar(e) {
      e.preventDefault();
      let servicoContrato = {
        Preco: this.servico.desconto
          ? this.servico.precoParceiro
          : this.servico.precoContratacao,
        TsContratacao: this.$moment().format(),
        ServicoId: this.servico.servicoId,
        Clienteid: this.cliente.ClienteId,
      };
      this.$http
        .post("contratacao/", servicoContrato)
        .then((res) => {
          this.contratacao = res.data;
            if (this.contratacao.pago){
                this.redireciona()
            }
          this.$store.commit("setEtapaInicial", "Pagamento");
        })
        .catch(() => {});
    },
    redireciona(){
      this.servicoscontrados = true
       
    }
  },

};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.card-header {
  font-weight: 700;
  font-size: 1.5em;
}
</style>